// Standard Object Factory
//
// Creates standard game objects
//
//  - Sprite
//  - Button
//  - Movie
//  - Text
//  - BitmapText

standardObjectFactory = {};
standardObjectFactory.movieFPS = 25;
standardObjectFactory.buttons = [];
standardObjectFactory.movies = [];
standardObjectFactory.textObjects = [];
standardObjectFactory.clocks = [];
standardObjectFactory.fpsCounters = [];
standardObjectFactory.translatableObjects = [];

// -------------------------------------------------
// Sprite
// -------------------------------------------------
standardObjectFactory.createSprite = function (json) {
  var sprite = new PIXI.Sprite.fromImage(
    gdk.ammendResourceName(ReflexLoader.rootResDir + json.fileName),
    'use-credentials'
  );
  if (json.interactive === true) {
    sprite.interactive = true;
  }

  if (json.anchor !== undefined) {
    if (typeof json.anchor === 'number') {
      sprite.anchor.set(json.anchor);
    } else {
      sprite.anchor.set(json.anchor.x, json.anchor.y);
    }
  } else {
    sprite.anchor.set(0);
  }

  sprite.setInteractiveCallbacks = function (callbackFunction, onRelease) {
    sprite.interactive = true;
    if (onRelease) {
      // Call function on release
      sprite.mouseup = sprite.touchend = callbackFunction;
    } else {
      // Call function on press
      sprite.mousedown = sprite.touchstart = callbackFunction;
    }
  };

  sprite.clearInteractiveCallbacks = function () {
    sprite.interactive = false;
    sprite.mousedown = sprite.touchstart = sprite.mouseup = sprite.touchend = undefined;
  };

  return sprite;
};
standardObjectFactory.initialiseSprite = function (json) {
  // Nothing else to do
};
standardObjectFactory.getSpriteFiles = function (json) {
  return [ReflexLoader.rootResDir + json.fileName];
};

// -------------------------------------------------
// Translatable Sprite
// -------------------------------------------------

standardObjectFactory.createTranslatableSprite = function (json) {
  if (checkForDefined(json.fileName)) {
    // Hijack the standard sprite
    return standardObjectFactory.createSprite(json);
  } else {
    return new PIXI.Container();
  }
};

standardObjectFactory.initialiseTranslatableSprite = function (json, object) {
  var sprite;

  // Create translated sprite objects
  object.translatedSprites = {};
  object.translatedSpritesKeys = Object.keys(json.translatedSprites);
  for (var i = 0; i < object.translatedSpritesKeys.length; i++) {
    var key = object.translatedSpritesKeys[i];
    if (typeof json.translatedSprites[key] !== 'object') {
      json.translatedSprites[key] = {
        fileName: json.translatedSprites[key],
      };
    }

    // Create the sprite
    sprite = resourceManager.createObject('sprite', 'translatedSprite' + i, object.name, json.translatedSprites[key]);

    if (json.anchor !== undefined) {
      if (typeof json.anchor === 'number') {
        sprite.anchor.set(json.anchor);
      } else {
        sprite.anchor.set(json.anchor.x, json.anchor.y);
      }
    } else {
      sprite.anchor.set(0);
    }

    sprite.visible = false;
    object.translatedSprites[key] = sprite;
  }

  // Create translation text objects
  object.translatedTextObjects = [];

  if (checkForDefined(json.text)) {
    for (var i = 0; i < json.text.length; i++) {
      object.translatedTextObjects.push(resourceManager.createObject('text', 'text' + i, object.name, json.text[i]));
    }
  }
  if (checkForDefined(json.sprite)) {
    for (var i = 0; i < json.sprite.length; i++) {
      object.translatedTextObjects.push(
        resourceManager.createObject('sprite', 'sprite' + i, object.name, json.sprite[i])
      );
    }
  }

  // Set language
  object.updateTranslationText = function () {
    var found = false;
    var currentLanguage = gdk.getCurrentLanguage();
    for (var i = 0; i < this.translatedSpritesKeys.length; i++) {
      found |= this.translatedSpritesKeys[i] === currentLanguage;
      this.translatedSprites[this.translatedSpritesKeys[i]].visible = this.translatedSpritesKeys[i] === currentLanguage;
    }

    for (var i = 0; i < object.translatedTextObjects.length; i++) {
      // Note translation of text is handled by text object
      this.translatedTextObjects[i].alpha = found ? 0 : 1;
    }
  };

  standardObjectFactory.translatableObjects.push(object);
  object.updateTranslationText();
};

standardObjectFactory.getTranslatableSpriteFiles = function (json) {
  var files = checkForDefined(json.fileName) ? [json.fileName] : [];
  var translatedSpritesKeys = Object.keys(json.translatedSprites);
  for (var i = 0; i < translatedSpritesKeys.length; i++) {
    file = json.translatedSprites[translatedSpritesKeys[i]];
    if (typeof file === 'object') {
      file = file.fileName;
    }
    if (files.indexOf(file) === -1) {
      files.push(file);
    }
  }

  return files;
};

// -------------------------------------------------
// Container
// -------------------------------------------------
standardObjectFactory.createContainer = function (json) {
  return new PIXI.Container();
};
standardObjectFactory.initialiseContainer = function (json) {
  // Nothing else to do
};
standardObjectFactory.getContainerFiles = function (json) {
  return [];
};

// -------------------------------------------------
// FPS counter
// -------------------------------------------------
standardObjectFactory.createFPScounter = function (json) {
  var fpsCounter = new PIXI.Container();

  if (standardObjectFactory.fpsCounters.length === 0) {
    // This is the first clock, so kick off update timer
    Reflex.addToUpdate(standardObjectFactory.updateFPScounters);
    standardObjectFactory.timeSinceUpdate = 0;
    standardObjectFactory.framesCount = 0;
  }

  var graphics = new PIXI.Graphics();
  graphics.beginFill(0, 1);
  graphics.drawRect(-100, -30, 200, 60);
  graphics.endFill();
  var text = new PIXI.Text('', {
    fill: '#FFFFFF',
  });
  text.anchor.set(0.5);
  standardObjectFactory.fpsCounters.push(fpsCounter);

  fpsCounter.addChild(graphics);
  fpsCounter.addChild(text);
  fpsCounter.counterText = text;

  return fpsCounter;
};
standardObjectFactory.initialiseFPScounter = function (json) {
  // Nothing else to do
};
standardObjectFactory.getFPScounterFiles = function (json) {
  return [];
};

standardObjectFactory.updateFPScounters = function (delta) {
  standardObjectFactory.timeSinceUpdate += delta;
  if (standardObjectFactory.timeSinceUpdate > 1000) {
    for (var i = 0; i < standardObjectFactory.fpsCounters.length; i++) {
      standardObjectFactory.fpsCounters[i].counterText.text = standardObjectFactory.framesCount + ' fps';
    }
    standardObjectFactory.framesCount = 0;
    standardObjectFactory.timeSinceUpdate = standardObjectFactory.timeSinceUpdate % 1000;
  }
  standardObjectFactory.framesCount++;
};

// -------------------------------------------------
// Button
// -------------------------------------------------
standardObjectFactory.waitingForFullScreenChange = false;

standardObjectFactory.onPrepareForFullScreen = function (button, pressedCallback, releasedCallback) {
  standardObjectFactory.buttonPressed = button;
  standardObjectFactory.buttonPressedCallback = pressedCallback;
  standardObjectFactory.buttonReleasedCallback = releasedCallback;
  standardObjectFactory.waitingForFullScreenChange = true;
};

standardObjectFactory.onWaitForFullScreen = function () {
  // Change to full screen
  gdk.requestFullscreen();

  Reflex.registerEventHandler('fullScreen', standardObjectFactory.onFullScreenChanged);
};

standardObjectFactory.onFullScreenChanged = function () {
  if (!standardObjectFactory.waitingForFullScreenChange) return;

  Reflex.deregisterEventHandler('fullScreen', standardObjectFactory.onFullScreenChanged);

  // Call button functions
  if (checkForDefined(standardObjectFactory.buttonPressedCallback)) standardObjectFactory.buttonPressedCallback();
  if (checkForDefined(standardObjectFactory.buttonReleasedCallback)) standardObjectFactory.buttonReleasedCallback();

  delete standardObjectFactory.buttonPressedCallback;
  delete standardObjectFactory.buttonReleasedCallback;

  standardObjectFactory.waitingForFullScreenChange = false;
};

standardObjectFactory.createButton = function (json) {
  var newButton = new PIXI.Container();
  newButton.isButtonEnabled = true;
  newButton.onPressedCallback = function () {};
  newButton.onReleasedCallback = function () {};
  newButton.onEnabledCallback = function () {};
  newButton.onDisabledCallback = function () {};
  newButton.keyCode = json.keyCode;

  newButton.enableButton = function (enabled) {
    var previousButtonState = newButton.isButtonEnabled;

    newButton.isButtonEnabled = enabled;
    if (!this.buttonPressed.visible) {
      newButton.buttonEnabled.visible = enabled;
      newButton.buttonDisabled.visible = !enabled;
    }

    if (previousButtonState !== newButton.isButtonEnabled) {
      if (typeof this.buttonText !== 'undefined') {
        this.buttonText.tint = enabled ? 0xffffff : 0x777777;
      }

      if (enabled) {
        newButton.onEnabledCallback();
        newButton.interactive = enabled;
      } else {
        newButton.onDisabledCallback();
      }
    }
  };

  // Create functions
  newButton.onPressed = function () {
    if (gdk.deviceInfo.mobile && !Reflex.getIsFullScreen() && gdk.canFullScreen()) {
      // We need to try and go into full screen
      standardObjectFactory.onPrepareForFullScreen(this, this.pressFunction, this.releaseFunction);
    } else {
      this.onPressedCallback();
    }

    this.buttonEnabled.visible = false;
    this.buttonPressed.visible = true;
  };

  newButton.pressFunction = function () {
    standardObjectFactory.buttonPressed.onPressedCallback();
  };

  newButton.onReleased = function () {
    if (checkForDefined(Howler.ctx) && Howler.ctx !== null) {
      // This has been added because sometimes on iOS / Safari the audio context is lost when minimising / restoring. The only way to get this back is to resume on a touch release.
      Howler.ctx.resume();
    }

    if (gdk.deviceInfo.mobile && !Reflex.getIsFullScreen() && gdk.canFullScreen()) {
      standardObjectFactory.onWaitForFullScreen();
    } else {
      this.buttonEnabled.visible = this.isButtonEnabled;
      this.buttonPressed.visible = false;
      this.buttonDisabled.visible = !this.isButtonEnabled;
      newButton.interactive = this.isButtonEnabled;
      this.onReleasedCallback();
    }
  };

  newButton.releaseFunction = function () {
    standardObjectFactory.buttonPressed.buttonEnabled.visible = standardObjectFactory.buttonPressed.isButtonEnabled;
    standardObjectFactory.buttonPressed.buttonPressed.visible = false;
    standardObjectFactory.buttonPressed.buttonDisabled.visible = !standardObjectFactory.buttonPressed.isButtonEnabled;

    if (typeof standardObjectFactory.buttonPressed.buttonText !== 'undefined') {
      standardObjectFactory.buttonPressed.buttonText.tint = standardObjectFactory.buttonPressed.isButtonEnabled
        ? 0xffffff
        : 0x777777;
    }

    newButton.interactive = standardObjectFactory.buttonPressed.isButtonEnabled;
    standardObjectFactory.buttonPressed.onReleasedCallback();
  };

  newButton.onOut = function () {
    // Cancel enable state
    if (this.buttonPressed.visible) {
      this.buttonEnabled.visible = this.isButtonEnabled;
      this.buttonPressed.visible = false;
      this.buttonDisabled.visible = !this.isButtonEnabled;
      this.interactive = this.isButtonEnabled;
    }
  };

  newButton.setKeyboardShortcut = function (keyCode) {
    this.keyCode = keyCode;
  };

  newButton.onKeyPressed = function (keyCode) {
    if (keyCode === this.keyCode && this.isButtonEnabled) {
      this.onPressed();
    }
  };

  newButton.onKeyReleased = function (keyCode) {
    if (keyCode === this.keyCode && this.isButtonEnabled) {
      this.onReleased();
    }
  };

  standardObjectFactory.buttons.push(newButton);
  return newButton;
};
standardObjectFactory.destroyButton = function (button) {
  var index = standardObjectFactory.buttons.indexOf(button);
  if (index === -1) {
    console.log('Could not destroy button as it could not be found');
    return;
  }

  standardObjectFactory.buttons.splice(index, 1);
};
standardObjectFactory.initialiseButton = function (json, object) {
  // Get texture width / height so we can offset button
  var texture = PIXI.utils.TextureCache[ReflexLoader.rootResDir + json.fileName + 'ON.png'];
  var x = json.center ? 0 : (texture.width / 2) * resourceManager.selectedAssetResolution.scaleFactor;
  var y = json.center ? 0 : (texture.height / 2) * resourceManager.selectedAssetResolution.scaleFactor;

  // Create sprites
  object.buttonEnabled = resourceManager.createObject('sprite', 'Enabled', json.FQN, {
    anchor: json.anchor,
    fileName: json.fileName + 'ON.png',
    x: x,
    y: y,
  });
  object.buttonEnabled.anchor.set(0.5);
  object.buttonEnabled.visible = true;

  object.buttonPressed = resourceManager.createObject('sprite', 'Pressed', json.FQN, {
    anchor: json.anchor,
    fileName: json.fileName + 'PRESSED.png',
    x: x,
    y: y,
  });
  object.buttonPressed.anchor.set(0.5);
  object.buttonPressed.visible = false;

  object.buttonDisabled = resourceManager.createObject('sprite', 'Disabled', json.FQN, {
    anchor: json.anchor,
    fileName: json.fileName + 'OFF.png',
    x: x,
    y: y,
  });
  object.buttonDisabled.anchor.set(0.5);
  object.buttonDisabled.visible = false;

  // Create button text
  if (checkForDefined(json.text) || checkForDefined(json.translationPhrase)) {
    json.text = checkForUndefined(json.text) ? '' : json.text;
    var textPos = {};
    textPos.x = typeof json.buttonX === 'undefined' ? 0 : json.buttonX;
    textPos.y = typeof json.buttonY === 'undefined' ? 0 : json.buttonY;
    object.buttonText = resourceManager.createObject('text', 'buttonText', json.FQN, {
      text: json.text,
      translationPhrase: json.translationPhrase,
      fontDefinition: json.fontDefinition,
      fontOverrides: json.fontOverrides,
      x: x + textPos.x,
      y: y + textPos.y,
      maxWidth: json.maxWidth,
      maxHeight: json.maxHeight,
    });

    object.setButtonText = function (text) {
      this.buttonText.text = text;
      this.buttonText.checkBounds();
    };
  } else {
    object.setButtonText = function (text) {
      console.log('Cannot set text on this button, as it didnt have text on when created');
    };
  }

  if (checkForDefined(object.buttonText)) {
    object.setTranslationPhrase = object.buttonText.setTranslationPhrase;
    object.setTranslationParameters = object.buttonText.setTranslationParameters;
  }

  // Set container to interactive and set up hit area
  object.interactive = true;
  var hitAreaScale = typeof json.hitAreaScale !== 'undefined' ? json.hitAreaScale : 1;
  var hitAreaWidth = object.buttonEnabled.width * hitAreaScale;
  var hitAreaHeight = object.buttonEnabled.height * hitAreaScale;
  var hitAreaX = json.center ? -hitAreaWidth / 2 : (object.buttonEnabled.width - hitAreaWidth) / 2;
  var hitAreaY = json.center ? -hitAreaHeight / 2 : (object.buttonEnabled.height - hitAreaHeight) / 2;
  object.hitArea = new PIXI.Rectangle(hitAreaX, hitAreaY, hitAreaWidth, hitAreaHeight);

  if (Reflex.developerModeData.showButtonHitAreas) {
    var graphics = new PIXI.Graphics();
    graphics.position.set(
      -object.buttonEnabled.width * object.buttonEnabled.anchor.x + hitAreaX,
      -object.buttonEnabled.height * object.buttonEnabled.anchor.y + hitAreaY
    );
    object.buttonEnabled.addChild(graphics);
    graphics.lineStyle(5, 0x00ff00, 0.5);
    graphics.drawRect(0, 0, hitAreaWidth, hitAreaHeight);
  }

  object.mousedown = object.touchstart = object.onPressed;
  object.mouseup = object.touchend = object.onReleased;
  object.mouseupoutside = object.touchendoutside = object.onOut;
  object.width = object.buttonEnabled.width;
  object.height = object.buttonEnabled.height;

  object.enableButton(false);
};
standardObjectFactory.getButtonFiles = function (json) {
  return [
    ReflexLoader.rootResDir + json.fileName + 'ON.png',
    ReflexLoader.rootResDir + json.fileName + 'OFF.png',
    ReflexLoader.rootResDir + json.fileName + 'PRESSED.png',
  ];
};

// -------------------------------------------------
// Movie
// -------------------------------------------------
standardObjectFactory.createMovie = function (json, cloneTextures) {
  var fps;
  var movieTextures;
  var textureListName;

  if (typeof json.definition !== 'undefined') {
    // This is a movie with a new style definition (all defined in movieDefinitions)
    var movieDef = resourceManager.getConfiguration().movieDefinitions[json.definition];
    textureListName = resourceManager.getConfiguration().movieDefinitions[json.definition].textureList;
    fps = resourceManager.getMovieFPS(json.definition);
  } else {
    // This is a movie with old style definition (texture list / fps defined in json)
    textureListName = json.textureList;
    fps = json.fps ? json.fps : standardObjectFactory.movieFPS;
    console.warn('Using textureList is obsolete, please use keyword definition (' + json.FQN + ')');
  }

  if (cloneTextures) {
    movieTextures = textureParser.getClonedTextureList(textureListName);
  } else {
    movieTextures = textureParser.getTextureList(textureListName);
  }

  var movie;
  switch (Reflex.PIXI_MAJOR_VERSION) {
    case 3:
      {
        movie = new PIXI.extras.MovieClip(movieTextures);
      }
      break;

    case 4:
      {
        movie = new PIXI.extras.AnimatedSprite(movieTextures);
      }
      break;
  }

  movie.paused = false;
  movie.animationSpeed = fps / 60;
  movie.loop = json.loop === undefined ? true : json.loop;
  movie.gotoAndPlay(0);

  if (json.anchor !== undefined) {
    if (typeof json.anchor === 'number') {
      movie.anchor.set(json.anchor);
    } else {
      movie.anchor.set(json.anchor.x, json.anchor.y);
    }
  } else {
    movie.anchor.set(0);
  }

  movie.setInteractiveCallbacks = function (callbackFunction, onRelease) {
    movie.interactive = true;
    if (onRelease) {
      // Call function on release
      movie.mouseup = movie.touchend = callbackFunction;
    } else {
      // Call function on press
      movie.mousedown = movie.touchstart = callbackFunction;
    }
  };

  movie.clearInteractiveCallbacks = function () {
    movie.interactive = false;
    movie.mousedown = movie.touchstart = movie.mouseup = movie.touchend = undefined;
  };

  standardObjectFactory.movies.push(movie);

  return movie;
};
standardObjectFactory.initialiseMovie = function (json) {};
standardObjectFactory.destroyMovie = function (movie) {
  var index = standardObjectFactory.movies.indexOf(movie);
  if (index === -1) {
    console.log('Could not destroy movie as it could not be found');
    return;
  }

  standardObjectFactory.movies.splice(index, 1);
};
standardObjectFactory.getMovieFiles = function (json) {
  if (typeof json.definition !== 'undefined') {
    // This is a movie with a new style definition (all defined in movieDefinitions
    if (typeof resourceManager.getConfiguration().movieDefinitions === 'undefined') {
      // No definition found in config
      console.log('No movieDefinitions section found in config.json');
      return;
    }

    var movieDefinition = resourceManager.getConfiguration().movieDefinitions[json.definition];
    if (typeof movieDefinition === 'undefined') {
      // Definition was not found
      console.log('Definition ' + json.definition + ' was not found in movieDefinitions for movie ' + json.ID);
      return;
    }

    // Get texture list this definition points to
    var list = textureParser.getFilesRequired(movieDefinition.textureList);
    return list;
  } else {
    // Old style definition
    var list = textureParser.getFilesRequired(json.textureList);
    return list;
  }
};

// -------------------------------------------------
// Text
// -------------------------------------------------
standardObjectFactory.checkValidFont = function (json) {
  if (typeof json.fontDefinition === 'undefined') {
    console.error(
      "A font definition needs to be assigned to object '" +
        json.ID +
        "' in layout.json. Use the fontDefinition keyword"
    );
    return false;
  }

  // Check we have a font configuration associated with this text
  var config = resourceManager.getConfiguration();
  var fontDef = config.fontDefinitions[json.fontDefinition];
  if (typeof fontDef === 'undefined') {
    console.error(
      'Font specified in layout.json (' + json.fontDefinition + ") for '" + json.ID + "' was not found in config.json"
    );
    return false;
  }

  if (fontDef.type !== 'bitmap' && fontDef.type !== 'system') {
    console.error("Error in font definition '" + json.fontDefinition + "' - supported types are bitmap or system");
    return false;
  }

  return true;
};

standardObjectFactory.createText = function (json) {
  if (standardObjectFactory.checkValidFont(json) === false) {
    return new PIXI.Container();
  }

  var textObject;

  var config = resourceManager.getConfiguration();
  var fontDef = config.fontDefinitions[json.fontDefinition];

  switch (fontDef.type) {
    case 'bitmap':
      {
        if (json.fontSize === undefined) json.fontSize = fontDef.fontSize;

        var defaultText = json.text || '';
        var textAlign = json.textAlign || 'center';
        var textFont = json.fontSize * resourceManager.selectedAssetResolution.scale + 'px ' + fontDef.fontName;

        textObject = new PIXI.extras.BitmapText(defaultText, {
          font: textFont,
          align: textAlign,
        });

        if (typeof json.maxWidth !== 'undefined') {
          textObject.maxWidthDisplay = json.maxWidth;
        }

        if (typeof json.maxHeight !== 'undefined') {
          textObject.maxHeightDisplay = json.maxHeight;
        }

        textObject.checkMaxWidth = function (objectScale) {
          // This has been left in for backwards compatibility
          this.checkBounds(objectScale);
        };

        textObject.checkBounds = function (objectScale = 1) {
          this.scale.x = 1;
          this.scale.y = 1;

          var scaleX = checkForDefined(json.maxWidth)
            ? (Math.min(this.width, json.maxWidth * resourceManager.selectedAssetResolution.scale) / this.width) *
              objectScale
            : objectScale;
          var scaleY = checkForDefined(json.maxHeight)
            ? (Math.min(this.height, json.maxHeight * resourceManager.selectedAssetResolution.scale) / this.height) *
              objectScale
            : objectScale;
          this.scale.x = scaleX;
          this.scale.y = scaleY;
          if (this.maintainAspectRatio) {
            this.scale.x = this.scale.y = Math.min(scaleX, scaleY);
          }
          this.scale.lastScaleX = this.scale.x;
          this.scale.lastScaleY = this.scale.x;
        };

        textObject.setMaxWidth = function (width) {
          this.maxWidth = width;
          this.Props.maxWidth = width;
          this.checkBounds();
        };

        textObject.setMaxHeight = function (height) {
          this.maxHeight = height;
          this.Props.maxHeight = height;
          this.checkBounds();
        };
      }
      break;

    case 'system':
      {
        var fontStyle;

        if (typeof json.fontOverrides === 'undefined') {
          // No overrides defined, so default blank
          json.fontOverrides = {};
        }

        switch (Reflex.PIXI_MAJOR_VERSION) {
          case 3:
            {
              // PIXI version 3 doesnt support PIXI.TextStyle;
              var fontStyle = {};

              for (var prop in fontDef.defaults) {
                if (fontDef.defaults.hasOwnProperty(prop)) {
                  fontStyle[prop] = json.fontOverrides[prop] || fontDef.defaults[prop];
                }
              }

              // do we have a replacement font based on locale?
              const locale = gdk.getCurrentLanguage();
              if (json.fontOverrides['fontFamilyFor_' + locale]) {
                // use this font family instead
                fontStyle['fontFamily'] = json.fontOverrides['fontFamilyFor_' + locale];
              } else if (fontDef.defaults['fontFamilyFor_' + locale]) {
                fontStyle['fontFamily'] = fontDef.defaults['fontFamilyFor_' + locale];
              }

              // Size must be included with font
              if (typeof fontStyle.fontSize !== 'undefined') {
                fontStyle.font =
                  fontStyle.fontSize * resourceManager.selectedAssetResolution.scale + 'px ' + fontStyle.fontFamily;
              }
              // PIXI 3 doesnt support gradient fonts
              if (typeof fontStyle.fill === 'object') {
                fontStyle.fill = fontStyle.fill[0];
              }
            }
            break;

          case 4:
            {
              fontStyle = new PIXI.TextStyle();

              for (var prop in fontStyle) {
                if (fontStyle.hasOwnProperty(prop)) {
                  if (prop.substr(0, 1) === '_') {
                    var thisProp = prop.substr(1, prop.length - 1);
                    fontStyle[thisProp] =
                      json.fontOverrides[thisProp] || fontDef.defaults[thisProp] || fontStyle[thisProp];
                  }
                }
              }

              // do we have a replacement font based on locale?
              const locale = gdk.getCurrentLanguage();
              if (json.fontOverrides['fontFamilyFor_' + locale]) {
                // use this font family instead
                fontStyle['fontFamily'] = json.fontOverrides['fontFamilyFor_' + locale];
              } else if (fontDef.defaults['fontFamilyFor_' + locale]) {
                fontStyle['fontFamily'] = fontDef.defaults['fontFamilyFor_' + locale];
              }

              // Things we need to take account of when applying scale. We cant apply scale to PIXI object as this may be over written by developer
              var propertiesToUpdate = ['fontSize', 'dropShadowDistance', 'strokeThickness'];
              for (var i = 0; i < propertiesToUpdate.length; i++) {
                if (typeof fontStyle[propertiesToUpdate[i]] !== 'undefined') {
                  fontStyle[propertiesToUpdate[i]] *= resourceManager.selectedAssetResolution.scale;
                }
              }

              // Dont allow gradient fonts on older devices as they are really slow
              if (gdk.deviceInfo.android && gdk.deviceInfo.osMajorVersion <= 5 && typeof fontStyle.fill === 'object') {
                fontStyle.fill = fontStyle.fill[0];
              }

              textObject = new PIXI.Text('', fontStyle);

              if (typeof json.maxWidth !== 'undefined') {
                textObject.maxWidth = json.maxWidth;
              }

              if (typeof json.maxHeight !== 'undefined') {
                textObject.maxHeight = json.maxHeight;
              }

              textObject.setMaxWidth = function (width) {
                this.maxWidth = width;
                this.Props.maxWidth = width;
                this.checkBounds();
              };

              textObject.setMaxHeight = function (height) {
                this.maxHeight = height;
                this.Props.maxHeight = height;
                this.checkBounds();
              };

              textObject.checkMaxWidth = function (objectScale) {
                // This has been left in for backwards compatibility
                this.checkBounds(objectScale);
              };

              textObject.checkBounds = function (objectScale) {
                if (checkForDefined(json.maxWidth) || checkForDefined(json.maxHeight)) {
                  if (typeof objectScale === 'undefined') {
                    objectScale = 1;
                  }
                  //this.updateText();
                  this.scale.x = 1; // NOTE: We reset scale to 1 so it sets width to original scale. Do not remove.
                  this.scale.y = 1; // NOTE: We reset scale to 1 so it sets height to original scale. Do not remove.

                  var scaleX = checkForDefined(json.maxWidth)
                    ? (Math.min(this.width, json.maxWidth * resourceManager.selectedAssetResolution.scale) /
                        this.width) *
                      objectScale
                    : objectScale;
                  var scaleY = checkForDefined(json.maxHeight)
                    ? (Math.min(this.height, json.maxHeight * resourceManager.selectedAssetResolution.scale) /
                        this.height) *
                      objectScale
                    : objectScale;
                  this.scale.x = scaleX;
                  this.scale.y = scaleY;
                  if (this.maintainAspectRatio) {
                    this.scale.x = this.scale.y = Math.min(scaleX, scaleY);
                  }
                  this.scale.lastScaleX = this.scale.x;
                  this.scale.lastScaleY = this.scale.x;
                }

                // -----------------------------------------------
                // Show box when maxWidth is set in DEVELOPER MODE
                // -----------------------------------------------
                if (
                  Reflex.developerModeData.highlightTranslatedText &&
                  (checkForDefined(json.translationPhrase) ||
                    checkForDefined(json.maxWidth) ||
                    checkForDefined(json.maxHeight))
                ) {
                  // Translatable text should have a max width. Show a nice box or X to assist developer
                  if (checkForUndefined(this.maxWidthGraphics)) {
                    this.maxWidthGraphics = new PIXI.Graphics();
                    this.addChild(this.maxWidthGraphics);
                  }

                  this.maxWidthGraphics.clear();

                  if (
                    checkForDefined(json.translationPhrase) &&
                    checkForUndefined(json.maxWidth) &&
                    checkForUndefined(json.maxHeight)
                  ) {
                    // Translation phrase with no max width or height defined so show X
                    this.maxWidthGraphics.lineStyle(5, 0xff0000, 0.5);
                    this.maxWidthGraphics.moveTo(-50, -50);
                    this.maxWidthGraphics.lineTo(50, 50);
                    this.maxWidthGraphics.moveTo(-50, 50);
                    this.maxWidthGraphics.lineTo(50, -50);
                  } else {
                    // Translation phrase and max width defined, so show max width as graphic
                    var width = checkForDefined(textObject.maxWidth)
                      ? (textObject.maxWidth * resourceManager.selectedAssetResolution.scale) /
                        textObject.scale.lastScaleX
                      : 10;
                    var height = checkForDefined(textObject.maxHeight)
                      ? (textObject.maxHeight * resourceManager.selectedAssetResolution.scale) /
                        textObject.scale.lastScaleY
                      : 10;
                    this.maxWidthGraphics.lineStyle(3, 0x000000, 0.5);
                    this.maxWidthGraphics.beginFill(0xff0000, 0.5);
                    this.maxWidthGraphics.drawRect(-width * this.anchor.x, -height * this.anchor.y, width, height);
                  }
                }
              };
            }
            break;

          default:
            {
              console.log('PIXI version is not supported');
            }
            break;
        }
      }
      break;
  }

  textObject.Props = json;

  textObject.maintainAspectRatio = checkForUndefined(json.maintainAspectRatio) ? true : json.maintainAspectRatio;

  textObject.setFont = function (fontDefinition) {
    var config = resourceManager.getConfiguration();
    var fontDef = config.fontDefinitions[fontDefinition];

    switch (fontDef.type) {
      case 'bitmap':
        {
          textObject.align = fontDef.defaults.align;
          textObject.font =
            fontDef.defaults.fontSize * resourceManager.selectedAssetResolution.scale + 'px ' + fontDef.fontName;
        }
        break;
      case 'system':
        {
          var fontStyle;

          switch (Reflex.PIXI_MAJOR_VERSION) {
            case 3:
              {
                fontStyle = {};

                for (var prop in fontDef.defaults) {
                  if (fontDef.defaults.hasOwnProperty(prop)) {
                    fontStyle[prop] = fontDef.defaults[prop];
                  }
                }
                // Size must be included with font
                if (typeof fontStyle.fontSize !== 'undefined') {
                  fontStyle.font =
                    fontStyle.fontSize * resourceManager.selectedAssetResolution.scale + 'px ' + fontStyle.fontFamily;
                }
                // PIXI 3 doesnt support gradient fonts
                if (typeof fontStyle.fill === 'object') {
                  fontStyle.fill = fontStyle.fill[0];
                }
              }
              break;
            case 4:
              {
                fontStyle = new PIXI.TextStyle();

                for (var prop in fontStyle) {
                  if (fontStyle.hasOwnProperty(prop)) {
                    if (prop.substr(0, 1) === '_') {
                      var thisProp = prop.substr(1, prop.length - 1);
                      fontStyle[thisProp] = fontDef.defaults[thisProp] || fontStyle[thisProp];
                    }
                  }
                }

                // do we have a replacement font based on locale?
                const locale = gdk.getCurrentLanguage();
                if (fontDef.defaults['fontFamilyFor_' + locale]) {
                  // use this font family instead
                  fontStyle['fontFamily'] = fontDef.defaults['fontFamilyFor_' + locale];
                }

                // Things we need to take account of when applying scale. We cant apply scale to PIXI object as this may be over written by developer
                var propertiesToUpdate = ['fontSize', 'dropShadowDistance', 'strokeThickness'];
                for (var i = 0; i < propertiesToUpdate.length; i++) {
                  if (typeof fontStyle[propertiesToUpdate[i]] !== 'undefined') {
                    fontStyle[propertiesToUpdate[i]] *= resourceManager.selectedAssetResolution.scale;
                  }
                }
                // Dont allow gradient fonts on older devices as they are really slow
                if (
                  gdk.deviceInfo.android &&
                  gdk.deviceInfo.osMajorVersion <= 5 &&
                  typeof fontStyle.fill === 'object'
                ) {
                  fontStyle.fill = fontStyle.fill[0];
                }
              }
              break;
          }

          textObject.style = fontStyle;
        }
        break;
    }
  };

  textObject.updateTranslationText = function () {
    if (checkForDefined(textObject.translationPhrase)) {
      // Translate this object
      this.setText(gdk.translateText(textObject.translationPhrase, textObject.translationParameters));
    }
  };

  textObject.setTranslationParameters = function () {
    this.translationParameters = [];
    for (var i = 0; i < arguments.length; i++) {
      this.translationParameters.push(arguments[i]);
    }
    this.updateTranslationText();
  };

  textObject.setTranslationPhrase = function (newPhrase) {
    textObject.translationPhrase = newPhrase;
    textObject.translationParameters = [];
    for (var i = 1; i < arguments.length; i++) {
      textObject.translationParameters.push(arguments[i]);
    }

    textObject.updateTranslationText();
  };

  textObject.getTranslationPhrase = function () {
    return this.translationPhrase;
  };

  if (json.anchor !== undefined) {
    if (typeof json.anchor === 'number') {
      textObject.anchor.set(json.anchor);
    } else {
      textObject.anchor.set(json.anchor.x, json.anchor.y);
    }
  } else {
    textObject.anchor.set(0.5);
  }

  textObject.setText = function (text) {
    var oldVisible = this.visible;
    this.visible = true;
    this.text = text;
    this.checkBounds(this.Props[layoutController.getCurrentLayout()].scale);
    this.visible = oldVisible;
  };

  if (checkForDefined(json.translationPhrase)) {
    textObject.translationPhrase = json.translationPhrase;
    textObject.translationParameters = [];
    standardObjectFactory.translatableObjects.push(textObject);

    // Initial translation
    //textObject.updateTranslationText();
  } else {
    textObject.text = json.text || '';
  }

  var scale = 1;
  if (
    checkForDefined(json[layoutController.getCurrentLayout()]) &&
    checkForDefined(json[layoutController.getCurrentLayout()].scale)
  ) {
    scale = json[layoutController.getCurrentLayout()].scale;
  }

  standardObjectFactory.textObjects.push(textObject);
  return textObject;
};

standardObjectFactory.destroyText = function (text) {
  var index = standardObjectFactory.textObjects.indexOf(text);
  if (index === -1) {
    console.log('Could not destroy text as it could not be found');
    return;
  }
  standardObjectFactory.textObjects.splice(index, 1);

  index = standardObjectFactory.translatableObjects.indexOf(text);
  if (index !== -1) {
    standardObjectFactory.translatableObjects.splice(index, 1);
  }

  // Now references are removed, destroy the texture the text object created
  if (checkForUndefined(text.texture)) {
    console.log('Text texture is not defined');
  } else {
    text.texture.destroy(true);
  }
};
standardObjectFactory.initialiseText = function (json, textObject) {
  textObject.updateTranslationText();
};
standardObjectFactory.getTextFiles = function (json) {
  if (standardObjectFactory.checkValidFont(json) === false) {
    return [];
  }

  var config = resourceManager.getConfiguration();
  var fontDef = config.fontDefinitions[json.fontDefinition];

  switch (fontDef.type) {
    case 'bitmap':
      {
        return [ReflexLoader.rootResDir + fontDef.fileName];
      }
      break;

    case 'system':
      {
        return [];
      }
      break;
  }
};

standardObjectFactory.createBitmapText = function (json) {};
standardObjectFactory.initialiseBitmapText = function (json) {};
standardObjectFactory.getBitmapTextFiles = function (json) {
  return textureParser.getFilesRequired(json.textureList);
};

standardObjectFactory.createTextInput = function (json) {
  return new PIXI.Container();
};

standardObjectFactory.initialiseTextInput = function (json, container) {
  container.textInput = new PIXI.TextInput({
    input: { fontSize: json.fontSize + 'px' },
    box: { fill: json.fill },
  });
  container.addChild(container.textInput);

  //container.textInput.width = json.width * resourceManager.selectedAssetResolution.scale;
};

standardObjectFactory.getTextInputFiles = function (json) {
  return [];
};

// -------------------------------------------------
// Simple Button
// -------------------------------------------------

standardObjectFactory.createSimpleButton = function (json) {
  var newButton = new PIXI.Container();
  newButton.isButtonEnabled = true;
  newButton.onPressedCallback = function () {};
  newButton.onReleasedCallback = function () {};
  newButton.onEnabledCallback = function () {};
  newButton.onDisabledCallback = function () {};
  newButton.keyCode = json.keyCode;
  newButton.animTime;
  newButton.isAnimating = false;

  if (checkForUndefined(json.animLength)) {
    console.error('Button ' + json.FQN + ' is missing animLength parameter');
  }

  if (checkForUndefined(json.pressedScale)) {
    console.error('Button ' + json.FQN + ' is missing pressedScale parameter');
  }

  newButton.enableButton = function (enabled) {
    newButton.isButtonEnabled = enabled;
    newButton.buttonSprite.alpha = enabled ? 1 : 0.8;
    newButton.buttonSprite.tint = enabled ? 0xffffff : 0x999999;

    if (typeof newButton.buttonText !== 'undefined') {
      newButton.buttonText.alpha = enabled ? 1 : 0.8;
      newButton.buttonText.tint = enabled ? 0xffffff : 0x999999;
    }

    if (enabled) {
      newButton.onEnabledCallback();
    } else {
      newButton.onDisabledCallback();
    }
  };

  // Create functions
  newButton.onPressed = function () {
    if (
      !newButton.isButtonEnabled ||
      !newButton.worldVisible ||
      newButton.worldAlpha === 0 ||
      resourceManager.getController('inputOverlord').areInputsBlocked() ||
      (newButton.parent &&
        newButton.parent.parent &&
        newButton.parent.parent.canEnable &&
        !newButton.parent.parent.canEnable())
    )
      return;

    resourceManager.getController('inputOverlord').blockButtonPresses(); //prevent presses from other buttons in the same frame
    var button = this.parent;
    newButton.animTime = newButton.Props.animLength;
    Reflex.addToUpdate(newButton.update);
    newButton.isAnimating = true;
    button.onPressedCallback();
  };

  newButton.update = function (delta, currentTime) {
    newButton.animTime = Math.max(0, newButton.animTime - delta);
    progress = 1 - newButton.animTime / newButton.Props.animLength;

    if (progress === 1) {
      // Animation complete
      newButton.isAnimating = false;
      Reflex.removeFromUpdate(newButton.update);
      newButton.buttonSprite.scale.set(1);
      if (newButton.buttonText) {
        var textScaleX = newButton.buttonText.scale.lastScaleX ? newButton.buttonText.scale.lastScaleX : 1;
        var textScaleY = newButton.buttonText.scale.lastScaleY ? newButton.buttonText.scale.lastScaleY : 1;
        newButton.buttonText.scale.x = textScaleX;
        newButton.buttonText.scale.y = textScaleY;
        newButton.buttonText.checkMaxWidth();
      }
    } else {
      var scale =
        newButton.Props.pressedScale +
        (1 - newButton.Props.pressedScale) * ((Math.cos(progress * Math.PI * 2) + 1) / 2);
      newButton.buttonSprite.scale.set(scale);
      if (newButton.buttonText) {
        var textScaleX = newButton.buttonText.scale.lastScaleX ? newButton.buttonText.scale.lastScaleX : 1;
        var textScaleY = newButton.buttonText.scale.lastScaleY ? newButton.buttonText.scale.lastScaleY : 1;
        newButton.buttonText.scale.x = textScaleX * scale;
        newButton.buttonText.scale.y = textScaleY * scale;
      }
    }
  };

  newButton.onReleased = function () {
    var button = this.parent;

    if (checkForDefined(Howler.ctx) && Howler.ctx !== null) {
      // This has been added because sometimes on iOS / Safari the audio context is lost when minimising / restoring. The only way to get this back is to resume on a touch release.
      Howler.ctx.resume();
    }

    if (gdk.deviceInfo.mobile && !Reflex.getIsFullScreen() && gdk.canFullScreen()) {
      standardObjectFactory.onWaitForFullScreen();
    }

    if (newButton.isButtonEnabled) {
      button.onReleasedCallback();
    }
  };

  newButton.setKeyboardShortcut = function (keyCode) {
    this.keyCode = keyCode;
  };

  newButton.onKeyPressed = function (keyCode) {
    if (keyCode === this.keyCode && this.isButtonEnabled) {
      this.buttonSprite.mousedown();
    }
  };

  newButton.onKeyReleased = function (keyCode) {
    if (keyCode === this.keyCode && this.isButtonEnabled) {
      this.buttonSprite.mouseup();
    }
  };

  standardObjectFactory.buttons.push(newButton);
  return newButton;
};

standardObjectFactory.destroySimpleButton = function (button) {
  var index = standardObjectFactory.buttons.indexOf(button);
  if (index === -1) {
    console.log('Could not destroy simple button as it could not be found');
    return;
  }

  standardObjectFactory.buttons.splice(index, 1);
};
standardObjectFactory.initialiseSimpleButton = function (json, object) {
  // Create sprites
  object.buttonSprite = resourceManager.createObject('sprite', 'buttonSprite', json.FQN, {
    anchor: json.anchor,
    fileName: json.fileName,
  });
  object.buttonSprite.visible = true;

  // Create button text
  if (typeof json.text !== 'undefined' || typeof json.translationPhrase !== 'undefined') {
    object.buttonText = resourceManager.createObject('text', 'buttonText', json.FQN, {
      text: json.text,
      translationPhrase: json.translationPhrase,
      maxWidth: json.maxWidth,
      maxHeight: json.maxHeight,
      fontDefinition: json.fontDefinition,
      fontOverrides: json.fontOverrides,
    });

    object.buttonText.textOffset = {
      x: json.textX || 0,
      y: json.textY || 0,
    };

    object.setButtonText = function (text) {
      this.buttonText.text = text;
      this.buttonText.checkMaxWidth();
    };

    //fully overriding this body originally from TEXT object for 2 reasons: the closure won't work if called directly, and 'arguments' is not the same as an array
    object.setTranslationParameters = function (args) {
      this.buttonText.translationParameters = [];
      for (var i = 0; i < args.length; i++) {
        this.buttonText.translationParameters.push(args[i]);
      }
      this.buttonText.updateTranslationText();
    };
  } else {
    object.setButtonText = function (text) {
      console.log('Cannot set text on this button, as it didnt have text on when created');
    };
  }

  if (checkForDefined(object.buttonText)) {
    object.setTranslationPhrase = object.buttonText.setTranslationPhrase;
  }

  if (typeof json.hitAreaCircle !== 'undefined') {
    var circle = json.hitAreaCircle;
    circle.radius *= resourceManager.selectedAssetResolution.scale;
    circle.x *= resourceManager.selectedAssetResolution.scale;
    circle.y *= resourceManager.selectedAssetResolution.scale;

    object.buttonSprite.hitArea = new PIXI.Circle(circle.x, circle.y, circle.radius);

    if (Reflex.developerModeData.showButtonHitAreas) {
      object.buttonSprite.graphics = new PIXI.Graphics();
      object.buttonSprite.graphics.beginFill(0xff0008);
      object.buttonSprite.graphics.lineStyle(4, 0xff0008, 1);
      object.buttonSprite.graphics.drawCircle(circle.x, circle.y, circle.radius);
      object.buttonSprite.graphics.endFill();
      object.buttonSprite.graphics.alpha = 0.5;
      object.buttonSprite.addChild(object.buttonSprite.graphics);
    }
  } else if (typeof json.hitAreaPolygon !== 'undefined') {
    var polygon = json.hitAreaPolygon;
    var scaledPolygon = [];
    polygon.forEach(function (value, index) {
      scaledPolygon.push(value * resourceManager.selectedAssetResolution.scale);
    });
    object.buttonSprite.hitArea = new PIXI.Polygon(scaledPolygon);

    if (Reflex.developerModeData.showButtonHitAreas) {
      object.buttonSprite.graphics = new PIXI.Graphics();
      object.buttonSprite.graphics.beginFill(0xff0008);
      object.buttonSprite.graphics.lineStyle(4, 0xff0008, 1);
      object.buttonSprite.graphics.drawPolygon(scaledPolygon);
      object.buttonSprite.graphics.endFill();
      object.buttonSprite.graphics.alpha = 0.5;
      object.buttonSprite.addChild(object.buttonSprite.graphics);
    }
  } else {
    var anchor = checkForDefined(json.anchor) ? json.anchor : 0.0;
    var hitAreaScale = typeof json.hitAreaScale !== 'undefined' ? json.hitAreaScale : 1;
    var hitAreaWidth = object.buttonSprite.width * hitAreaScale;
    var hitAreaHeight = object.buttonSprite.height * hitAreaScale;
    var hitAreaX = -(hitAreaWidth * anchor);
    var hitAreaY = -(hitAreaHeight * anchor);
    object.buttonSprite.hitArea = new PIXI.Rectangle(hitAreaX, hitAreaY, hitAreaWidth, hitAreaHeight);

    if (Reflex.developerModeData.showButtonHitAreas) {
      var graphics = new PIXI.Graphics();
      object.buttonSprite.addChild(graphics);
      graphics.lineStyle(5, 0x00ff00, 0.5);
      graphics.drawRect(hitAreaX, hitAreaY, hitAreaWidth, hitAreaHeight);
    }
  }

  object.buttonSprite.interactive = true;
  object.buttonSprite.mousedown = object.buttonSprite.touchstart = object.onPressed;
  object.buttonSprite.mouseup = object.buttonSprite.touchend = object.onReleased;
  object.buttonSprite.mouseupoutside = object.buttonSprite.touchendoutside = object.onOut;
  object.width = object.buttonSprite.width;
  object.height = object.buttonSprite.height;
  object.enableButton(false);
};

standardObjectFactory.getSimpleButtonFiles = function (json) {
  return [ReflexLoader.rootResDir + json.fileName];
};
// -------------------------------------------------
// Toggle Button
// -------------------------------------------------
standardObjectFactory.createToggleButton = function (json) {
  var newToggleButton = new PIXI.Container();
  newToggleButton.isButtonEnabled = true;
  newToggleButton.onPressedCallback = function () {};
  newToggleButton.onReleasedCallback = function () {};
  newToggleButton.onEnabledCallback = function () {};
  newToggleButton.onDisabledCallback = function () {};
  newToggleButton.keyCode = json.keyCode;

  newToggleButton.enableButton = function (enabled) {
    var previousButtonState = newToggleButton.isButtonEnabled;
    newToggleButton.isButtonEnabled = enabled;

    newToggleButton.buttonEnabled.tint = enabled ? 0xffffff : 0x777777;
    newToggleButton.buttonDisabled.tint = enabled ? 0xffffff : 0x777777;
    if (newToggleButton.buttonText) {
      newToggleButton.buttonText.tint = enabled ? 0xffffff : 0x777777;
    }

    newToggleButton.interactive = enabled;
    if (previousButtonState !== newToggleButton.isButtonEnabled) {
      if (enabled) {
        newToggleButton.onEnabledCallback();
      } else {
        newToggleButton.onDisabledCallback();
      }
    }
  };

  newToggleButton.toggle = function () {
    if (this.buttonEnabled.visible) {
      this.buttonEnabled.visible = false;
      this.buttonDisabled.visible = true;
      this.state = false;
    } else {
      this.buttonEnabled.visible = true;
      this.buttonDisabled.visible = false;
      this.state = true;
    }
  };

  // Create functions
  newToggleButton.onPressed = function () {
    this.toggle();
    this.onPressedCallback();

    if (checkForDefined(newToggleButton.Props.pressedScale) && checkForDefined(newToggleButton.Props.animLength)) {
      newToggleButton.animTime = newToggleButton.Props.animLength;
      if (!newToggleButton.isAnimating) {
        Reflex.addToUpdate(newToggleButton.update);
      }
      newToggleButton.isAnimating = true;
    }
  };

  newToggleButton.update = function (delta, currentTime) {
    newToggleButton.animTime = Math.max(0, newToggleButton.animTime - delta);
    progress = 1 - newToggleButton.animTime / newToggleButton.Props.animLength;

    if (progress === 1) {
      // Animation complete
      newToggleButton.isAnimating = false;
      Reflex.removeFromUpdate(newToggleButton.update);
      newToggleButton.buttonEnabled.scale.set(1);
      newToggleButton.buttonDisabled.scale.set(1);
      if (newToggleButton.buttonText) {
        var textScaleX = newToggleButton.buttonText.scale.lastScaleX ? newToggleButton.buttonText.scale.lastScaleX : 1;
        var textScaleY = newToggleButton.buttonText.scale.lastScaleY ? newToggleButton.buttonText.scale.lastScaleY : 1;
        newToggleButton.buttonText.scale.x = textScaleX;
        newToggleButton.buttonText.scale.y = textScaleY;
        newToggleButton.buttonText.checkMaxWidth();
      }
    } else {
      var scale =
        newToggleButton.Props.pressedScale +
        (1 - newToggleButton.Props.pressedScale) * ((Math.cos(progress * Math.PI * 2) + 1) / 2);
      newToggleButton.buttonEnabled.scale.set(scale);
      newToggleButton.buttonDisabled.scale.set(scale);
      if (newToggleButton.buttonText) {
        var textScaleX = newToggleButton.buttonText.scale.lastScaleX ? newToggleButton.buttonText.scale.lastScaleX : 1;
        var textScaleY = newToggleButton.buttonText.scale.lastScaleY ? newToggleButton.buttonText.scale.lastScaleY : 1;
        newToggleButton.buttonText.scale.x = textScaleX * scale;
        newToggleButton.buttonText.scale.y = textScaleY * scale;
      }
    }
  };

  newToggleButton.setKeyboardShortcut = function (keyCode) {
    this.keyCode = keyCode;
  };

  newToggleButton.onKeyPressed = function (keyCode) {
    if (keyCode === this.keyCode && this.isButtonEnabled) {
      this.onPressed();
    }
  };

  standardObjectFactory.buttons.push(newToggleButton);
  return newToggleButton;
};

standardObjectFactory.initialiseToggleButton = function (json, object) {
  // Get base texture width / height so we can offset button
  var anchor = checkForDefined(json.anchor) ? json.anchor : 0.5;
  var texture = PIXI.utils.TextureCache[ReflexLoader.rootResDir + json.fileName + 'ON.png'];
  var tw = (texture.width / 2) * resourceManager.selectedAssetResolution.scaleFactor;
  var th = (texture.height / 2) * resourceManager.selectedAssetResolution.scaleFactor;
  object.state = typeof json.toggleOn == 'boolean' ? json.toggleOn : true;

  // Create sprites
  object.buttonEnabled = resourceManager.createObject('sprite', 'Enabled', object.name, {
    fileName: json.fileName + 'ON.png',
    anchor: json.anchor,
  });
  object.buttonEnabled.visible = object.state;

  object.buttonDisabled = resourceManager.createObject('sprite', 'Disabled', object.name, {
    fileName: json.fileName + 'OFF.png',
    anchor: json.anchor,
  });
  object.buttonDisabled.visible = !object.state;

  // Set container to interactive and set up hit area
  object.interactive = true;

  if (typeof json.hitAreaCircle !== 'undefined') {
    var circle = json.hitAreaCircle;
    circle.radius *= resourceManager.selectedAssetResolution.scale;
    circle.x *= resourceManager.selectedAssetResolution.scale;
    circle.y *= resourceManager.selectedAssetResolution.scale;

    object.hitArea = new PIXI.Circle(circle.x, circle.y, circle.radius);

    if (Reflex.developerModeData.showButtonHitAreas) {
      object.graphics = new PIXI.Graphics();
      object.graphics.beginFill(0xff0008);
      object.graphics.lineStyle(4, 0xff0008, 1);
      object.graphics.drawCircle(circle.x, circle.y, circle.radius);
      object.graphics.endFill();
      object.graphics.alpha = 0.5;
      object.addChild(object.graphics);
    }
  } else if (typeof json.hitAreaPolygon !== 'undefined') {
    var polygon = json.hitAreaPolygon;
    var scaledPolygon = [];
    polygon.forEach(function (value, index) {
      scaledPolygon.push(value * resourceManager.selectedAssetResolution.scale);
    });
    object.hitArea = new PIXI.Polygon(scaledPolygon);

    if (Reflex.developerModeData.showButtonHitAreas) {
      object.graphics = new PIXI.Graphics();
      object.graphics.beginFill(0xff0008);
      object.graphics.lineStyle(4, 0xff0008, 1);
      object.graphics.drawPolygon(scaledPolygon);
      object.graphics.endFill();
      object.graphics.alpha = 0.5;
      object.addChild(object.graphics);
    }
  } else {
    var hitAreaScale = typeof json.hitAreaScale !== 'undefined' ? json.hitAreaScale : 1;
    var hitAreaWidth = object.buttonEnabled.width * hitAreaScale;
    var hitAreaHeight = object.buttonEnabled.height * hitAreaScale;
    var hitAreaX = anchor * -hitAreaWidth;
    var hitAreaY = anchor * -hitAreaHeight;
    object.hitArea = new PIXI.Rectangle(hitAreaX, hitAreaY, hitAreaWidth, hitAreaHeight);
  }

  if (Reflex.developerModeData.showButtonHitAreas) {
    var graphics = new PIXI.Graphics();
    graphics.position.set(
      -object.buttonEnabled.width * object.buttonEnabled.anchor.x + hitAreaX,
      -object.buttonEnabled.height * object.buttonEnabled.anchor.y + hitAreaY
    );
    object.buttonEnabled.addChild(graphics);
    graphics.lineStyle(3, 0xff0000, 0.5);
    graphics.drawRect(-hitAreaX, -hitAreaY, hitAreaWidth, hitAreaHeight);
  }

  if (json.translationPhrase && json.fontDefinition) {
    object.buttonText = resourceManager.createObject('text', 'text', object.name, {
      fontDefinition: json.fontDefinition,
      translationPhrase: json.translationPhrase,
      maxWidth: json.maxWidth,
      maxHeight: json.maxHeight,
      fontOverrides: json.fontOverrides,
    });
  }

  object.mousedown = object.touchstart = object.onPressed;
  object.width = object.buttonEnabled.width;
  object.height = object.buttonEnabled.height;

  if (object.buttonText) {
    // Set shortcuts to setting translation phrase / parameters
    object.setTranslationPhrase = object.buttonText.setTranslationPhrase;
    object.setTranslationParameters = object.buttonText.setTranslationParameters;
  }

  object.enableButton(false);
};
standardObjectFactory.getToggleButtonFiles = function (json) {
  return [ReflexLoader.rootResDir + json.fileName + 'ON.png', ReflexLoader.rootResDir + json.fileName + 'OFF.png'];
};

// -------------------------------------------------
// Graphics
// -------------------------------------------------
standardObjectFactory.createGraphics = function (json) {
  var graphic = new PIXI.Graphics();

  Object.keys(resourceManager.getConfiguration().layouts).forEach(function (element) {
    if (json[element] !== undefined) {
      if (json[element].scale === undefined) {
        json[element].scale = resourceManager.selectedAssetResolution.scale;
      } else {
        json[element].scale *= resourceManager.selectedAssetResolution.scale;
      }
    }
  });

  return graphic;
};
standardObjectFactory.initialiseGraphics = function (json, object) {};
standardObjectFactory.getGraphicsFiles = function (json) {
  return [];
};

// -------------------------------------------------
// Tiling Sprite
// -------------------------------------------------
standardObjectFactory.createTilingSprite = function (json) {
  var texture = PIXI.utils.TextureCache[ReflexLoader.rootResDir + json.fileName];
  var tilingSprite = new PIXI.extras.TilingSprite(texture, json.width, json.height);
  //tilingSprite.matchContainerWidth = json.matchContainerWidth | false;
  //tilingSprite.matchContainerHeight = matchContainerHeight | false;
  return tilingSprite;
};
standardObjectFactory.initialiseTilingSprite = function (json, object) {};
standardObjectFactory.getTilingsSpriteFiles = function (json) {
  return [ReflexLoader.rootResDir + json.fileName];
};

// -------------------------------------------------
// Clock
// -------------------------------------------------

standardObjectFactory.clockMode = 'ALWAYS';

standardObjectFactory.createClock = function (json) {
  var clock = new PIXI.Container();

  if (standardObjectFactory.clocks.length === 0) {
    // This is the first clock, so kick off update timer
    timerManager.addTimer(1, undefined, standardObjectFactory.updateClocks);
  }

  standardObjectFactory.clocks.push(clock);
  return clock;
};
standardObjectFactory.destroyClock = function (clock) {
  var index = standardObjectFactory.clocks.indexOf(clock);
  if (index === -1) {
    console.log('Could not destroy clock as it could not be found');
    return;
  }

  standardObjectFactory.clocks.splice(index, 1);
};
standardObjectFactory.initialiseClock = function (json, object) {
  if (json.width > 0 && json.height > 0) {
    graphics = new PIXI.Graphics();
    graphics.beginFill(0x000000, 0.6);
    graphics.lineStyle(3, 0x000000, 1);
    graphics.drawRect(
      0,
      0,
      json.width / resourceManager.selectedAssetResolution.scaleFactor,
      json.height / resourceManager.selectedAssetResolution.scaleFactor
    );
    graphics.endFill();
    object.addChild(graphics);
  }

  object.clockFormatString = json.format || 'HH : MM';
  object.timeText = resourceManager.createObject('text', 'clockText', json.FQN, {
    text: '',
    fontDefinition: json.fontDefinition,
    fontOverrides: json.fontOverrides,
    x: json.width / 2,
    y: json.height / 2,
  });

  object.visible = standardObjectFactory.canShowClock();
};

standardObjectFactory.updateClocks = function () {
  var date = new Date();
  h = ('0' + date.getHours()).slice(-2);
  m = ('0' + date.getMinutes()).slice(-2);
  s = ('0' + date.getSeconds()).slice(-2);

  for (var i = 0; i < standardObjectFactory.clocks.length; i++) {
    var clockString = standardObjectFactory.clocks[i].clockFormatString;
    clockString = clockString.replace(/HH/g, h);
    clockString = clockString.replace(/MM/g, m);
    clockString = clockString.replace(/SS/g, s);
    standardObjectFactory.clocks[i].timeText.setText(clockString);
  }

  timerManager.addTimer(1000, undefined, function () {
    standardObjectFactory.updateClocks();
  });
};

standardObjectFactory.canShowClock = function () {
  return standardObjectFactory.clockMode !== 'NEVER';
};

standardObjectFactory.onClockConfig = function (config) {
  if (
    checkForDefined(config.data) &&
    checkForDefined(config.data.uiElements) &&
    checkForDefined(config.data.uiElements.uiClock)
  ) {
    standardObjectFactory.clockMode = config.data.uiElements.uiClock;
  } else {
    standardObjectFactory.clockMode = 'ALWAYS';
  }
  standardObjectFactory.updateClocksVisibility();
};

standardObjectFactory.updateClocksVisibility = function () {
  var showClock = standardObjectFactory.canShowClock();

  // Set all current clocks to be visible dependent on config setting
  for (var i = 0; i < standardObjectFactory.clocks.length; i++) {
    standardObjectFactory.clocks[i].visible = showClock;
  }
};

standardObjectFactory.getClockFiles = function (json) {
  return [];
};

// -------------------------------------------------
//  Winline Diagram
// -------------------------------------------------

standardObjectFactory.winlineDiagram = (function () {
  var _winlineDiagrams = [];

  function createWinlineDiagram(json) {
    var graphic = new PIXI.Graphics();

    Object.keys(resourceManager.getConfiguration().layouts).forEach(function (element) {
      if (json[element] !== undefined) {
        if (json[element].scale === undefined) {
          json[element].scale = resourceManager.selectedAssetResolution.scale;
        } else {
          json[element].scale *= resourceManager.selectedAssetResolution.scale;
        }
      }
    });
    return graphic;
  }

  function initialiseWinlineDiagram(json, graphic) {
    graphic.winlineBoxWidth = json.boxWidth || 200;
    graphic.winlineBoxHeight = json.boxHeight || 100;
    graphic.winlineColour = json.winlineColour || 0xff0000;
    graphic.smallBoxColour = json.smallBoxColour || 0xffffff;
    graphic.outlineColours = json.outlineColours || [0x2d2d36];
    graphic.outlineStroke = json.outlineStroke || 9;
    graphic.anchor = json.anchor || 0.5;
    graphic.winlineNumber = json.winlineNumber - 1 || 0;
    graphic.reels = json.reels || 5;
    graphic.rows = json.rows || 3;
    graphic.xCorrection = -graphic.winlineBoxWidth * graphic.anchor;
    graphic.yCorrection = -graphic.winlineBoxHeight * graphic.anchor;
    graphic.dropsize = json.dropsize || 6;
    graphic.backgroundColour = json.backgroundColour;
    graphic.spotOffset = json.spotOffset || 0;

    // This will either take a colour Value from the winlineDiagram Json as a override or it will take if from from the config.
    graphic.winlineColour =
      json.winlineColour || resourceManager.getConfiguration().winlineColours[json.winlineNumber] || '0xFF0000';

    if (graphic.backgroundColour) {
      graphic.beginFill(graphic.backgroundColour, 1);
      graphic.drawRect(
        graphic.xCorrection - graphic.outlineStroke / 2,
        graphic.yCorrection - graphic.outlineStroke / 2,
        graphic.winlineBoxWidth + graphic.outlineStroke,
        graphic.winlineBoxHeight + graphic.outlineStroke
      );
      graphic.endFill();
    }

    //If outlines and stroke are not specified it will use defaults
    graphic.outlineColours.forEach(function (undefined, index) {
      var size = graphic.outlineStroke - index * (graphic.outlineStroke / graphic.outlineColours.length);
      graphic.lineStyle(size, graphic.outlineColours[index]);
      graphic.drawRect(
        graphic.xCorrection - graphic.outlineStroke / 2,
        graphic.yCorrection - graphic.outlineStroke / 2,
        graphic.winlineBoxWidth + graphic.outlineStroke,
        graphic.winlineBoxHeight + graphic.outlineStroke
      );
    });
    _winlineDiagrams.push(graphic);
  }

  function drawInternalBoxes(slotConfigTask) {
    // if there's no winline Diagrams Return
    if (_winlineDiagrams === undefined || _winlineDiagrams.length === 0) return;

    //wait for the config task so we know what to draw
    _winlineDiagrams.forEach(function (value, index) {
      var smallBoxWidth = (value.winlineBoxWidth - value.dropsize * (value.reels - 1)) / value.reels;
      var smallBoxHeight = (value.winlineBoxHeight - value.dropsize * (value.rows - 1)) / value.rows;

      for (i = 0; i < value.reels; ++i) {
        var lit = slotConfigTask.data.slotConfig.paylines[value.winlineNumber].spots[i] - value.spotOffset;
        for (j = 0; j < value.rows; ++j) {
          var boxColour = lit === j ? value.winlineColour : value.smallBoxColour;
          var innerColour = getDarkerColour(boxColour);
          var shadowColour = getDarkerColour(innerColour);
          value.lineStyle(0, 0);

          value.beginFill(boxColour, 1);
          value.drawRect(
            i * (smallBoxWidth + value.dropsize) + value.xCorrection,
            j * (smallBoxHeight + value.dropsize) + value.yCorrection,
            smallBoxWidth,
            smallBoxHeight
          );
          value.endFill();

          value.beginFill(innerColour, 1);
          value.drawRect(
            i * (smallBoxWidth + value.dropsize) + value.xCorrection + value.dropsize,
            j * (smallBoxHeight + value.dropsize) + value.yCorrection + value.dropsize,
            smallBoxWidth - value.dropsize * 2,
            smallBoxHeight - value.dropsize * 2
          );
          value.endFill();

          value.lineStyle(1, shadowColour);
          for (var k = 0; k <= value.dropsize; k++) {
            value.moveTo(
              (i + 1) * (smallBoxWidth + value.dropsize) - value.dropsize - k + value.xCorrection,
              j * (smallBoxHeight + value.dropsize) + k + value.yCorrection
            );
            value.lineTo(
              (i + 1) * (smallBoxWidth + value.dropsize) - value.dropsize - k + value.xCorrection,
              (j + 1) * (smallBoxHeight + value.dropsize) - value.dropsize - k + value.yCorrection
            );
            value.lineTo(
              i * (smallBoxWidth + value.dropsize) + k + value.xCorrection,
              (j + 1) * (smallBoxHeight + value.dropsize) - value.dropsize - k + value.yCorrection
            );
          }
        }
      }
    });
    _winlineDiagrams = null;
  }

  function getDarkerColour(colour) {
    var r = (colour >> 16) & 0xff;
    var g = (colour >> 8) & 0xff;
    var b = colour & 0xff;

    r *= 0.8;
    g *= 0.8;
    b *= 0.8;

    return (r << 16) + (g << 8) + b;
  }

  function getWinlineDiagramFiles(json) {
    return [];
  }

  return {
    create: createWinlineDiagram,
    initialise: initialiseWinlineDiagram,
    drawInternalBoxes: drawInternalBoxes,
    getFiles: getWinlineDiagramFiles,
    winlineDiagrams: _winlineDiagrams,
  };
})();

// -------------------------------------------------
//  PayTable
// -------------------------------------------------

standardObjectFactory.payTable = (function () {
  var _payTables = [];

  function create(json) {
    var graphic = new PIXI.Graphics();

    Object.keys(resourceManager.getConfiguration().layouts).forEach(function (element) {
      if (json[element] !== undefined) {
        if (json[element].scale === undefined) {
          json[element].scale = resourceManager.selectedAssetResolution.scale;
        } else {
          json[element].scale *= resourceManager.selectedAssetResolution.scale;
        }
      }
    });
    return graphic;
  }

  function initialise(json, graphic) {
    graphic.showWinsInCurrency = json.showWinsInCurrency;
    graphic.fontDefinition = checkForDefined(json.fontDefinition) ? json.fontDefinition : 'standard';
    graphic.tableWidth = json.width;
    graphic.tableHeight = json.height;
    graphic.winPlanID = json.winPlanID;
    graphic.symbolID = json.symbolID;
    graphic.fontSize = json.fontSize;
    graphic.countFontSize = json.countFontSize;
    graphic.countWidthMultiplier = json.countWidthMultiplier;
    graphic.singleText = json.singleText;
    graphic.countFormats = json.countFormats;
    graphic.lineStroke = 3 || json.lineStroke;
    graphic.dropShadowSize = 10 || json.dropShadowSize;
    graphic.maxWidths = json.maxWidths;
    graphic.horizontalSpacing = json.horizontalSpacing;
    graphic.anchor = json.anchor;
    graphic.valueWidthMultiplier = json.valueWidthMultiplier;
    graphic.valueXMultiplier = json.valueXMultiplier;

    if (json.fileName) {
      const graphicWidth = PIXI.utils.TextureCache[ReflexLoader.rootResDir + json.fileName].orig.width;
      const graphicHeight = PIXI.utils.TextureCache[ReflexLoader.rootResDir + json.fileName].orig.height;
      const targetWidth = json.width / 2 - 4;
      const targetHeight = json.height - 4;
      const scale = json.scale ? json.scale : Math.min(targetWidth / graphicWidth, targetHeight / graphicHeight);

      // As the size of the tableWidth changes with the scale factor, the graphics needs to take account of this otherwise scale is effectively applied twice
      graphic.symbol = resourceManager.createObject('sprite', 'symbolGraphic', json.FQN, {
        fileName: json.fileName,
        x: (-graphic.tableWidth / 4) * resourceManager.selectedAssetResolution.scaleFactor,
        anchor: 0.5,
        scale: scale,
      });
    }

    _payTables.push(graphic);
  }

  function draw(slotConfig) {
    // Store config, in case we need to change values later
    standardObjectFactory.payTable.slotConfig = slotConfig;

    // if there's no paytable objects Return
    if (_payTables === undefined || _payTables.length === 0) return;

    const paytable = slotConfig.data.slotConfig.prizeTable;
    const stakeController = resourceManager.getController('stakeController');

    // Makes some nice data to use for drawing
    // Might have to change this if the winplan naming convention changes because it uses regex on the winPlan ID strings
    _payTables.forEach(function (value, index) {
      value.uniqueID = 0;
      if (paytable[0].hasOwnProperty('phraseId')) {
        const paytablePayouts = [];
        const regex = new RegExp('_' + value.winPlanID + '_', undefined);
        for (let i = 0; i < paytable.length; ++i) {
          if (regex.test(paytable[i].phraseId)) {
            while (paytable[i] && regex.test(paytable[i].phraseId)) {
              paytable[i].multiplier = Number(paytable[i].phraseId.substr(-1));
              paytablePayouts.push(paytable[i]);
              ++i;
            }
            paytablePayouts.reverse();
            value.paytablePayouts = paytablePayouts;
            break;
          }
        }
      } else {
        value.paytablePayouts = paytable
          .filter(function (x) {
            return x.id === value.Props.symbolID;
          })
          .reverse();
      }

      // number of symbol text
      const textOffset = 1 / value.paytablePayouts.length;
      if (_payTables[index].singleText !== true) {
        for (let j = 0; j < value.paytablePayouts.length; j++) {
          const text = resourceManager.createObject('text', getuniqueId(), value.name, {
            x: (-value.tableWidth / 2 + value.tableWidth * 0.575) * resourceManager.selectedAssetResolution.scaleFactor,
            y:
              (-value.tableHeight / 2 + value.tableHeight * (j * textOffset + textOffset * 0.5)) *
              resourceManager.selectedAssetResolution.scaleFactor,
            fontDefinition: 'paytableFont',
            maxWidth:
              (value.tableWidth * (_payTables[index].countWidthMultiplier ?? 0.2) - value.lineStroke * 2) * resourceManager.selectedAssetResolution.scaleFactor,
            fontOverrides: {
              fontSize: _payTables[index].countFontSize ?? (_payTables[index].fontSize === undefined ? 28 : _payTables[index].fontSize),
            },
          });
          const count = paytable[0].hasOwnProperty('phraseId')
            ? value.paytablePayouts[j].multiplier
            : value.paytablePayouts[j].count;
          const formatted = value.countFormats && value.countFormats[count];
          text.setText(formatted !== undefined ? formatted : 'x' + count);
          text.anchor.set(0.5);
        }
      } else {
        // we dont need the x3, x4, x5 as seperate text
      }

      // payout text
      for (let k = 0; k < value.paytablePayouts.length; k++) {
        const widthPerc = _payTables[index].singleText ? 1 : 0.92;
        let maxWidth =
          _payTables[index].maxWidths === undefined
            ? (value.tableWidth * (_payTables[index].valueWidthMultiplier ?? 0.45) - value.lineStroke * 2) * resourceManager.selectedAssetResolution.scaleFactor
            : _payTables[index].maxWidths[k];
        if (_payTables[index].singleText) {
          // include the width of the x2 multiplier etc
          maxWidth +=
            (value.tableWidth * 0.2 - value.lineStroke * 2) * resourceManager.selectedAssetResolution.scaleFactor;
        }
        let x =
          _payTables[index].horizontalSpacing === undefined
            ? (-value.tableWidth / 2 + value.tableWidth * (_payTables[index].valueXMultiplier ?? widthPerc)) *
              resourceManager.selectedAssetResolution.scaleFactor
            : _payTables[index].horizontalSpacing;
        if (_payTables[index].singleText) {
          if (_payTables[index].anchor !== undefined && _payTables[index].anchor.x === 1) {
            x = maxWidth;
          } else {
            x = 0;
          }
        }
        const text = resourceManager.createObject('text', getuniqueId(), value.name, {
          x: x,
          y:
            (-value.tableHeight / 2 + value.tableHeight * (k * textOffset + textOffset * 0.5)) *
            resourceManager.selectedAssetResolution.scaleFactor,
          fontDefinition: 'paytableFont',
          maxWidth: maxWidth,
          fontOverrides: {
            fontSize: _payTables[index].fontSize === undefined ? 28 : _payTables[index].fontSize,
          },
        });

        if (value.paytablePayouts[k].value > 0) {
          const coins = slotConfig.data.slotConfig.coins || slotConfig.data.slotConfig.defaultNumLines;
          text.stakeMultiplier = value.paytablePayouts[k].value / coins;
          let textValue = 'x' + text.stakeMultiplier;
          if (value.showWinsInCurrency) {
            const stake = stakeController.CurrentBetPerLine * stakeController.CurrentWinLineCount;
            textValue = gdk.formatCurrency(text.stakeMultiplier * stake);
          }
          if (_payTables[index].singleText) {
            text.oak = value.paytablePayouts[k].count;
            text.setText(`x${value.paytablePayouts[k].count} ${textValue}`);
          } else {
            text.setText(textValue);
          }
          text.anchor.set(
            _payTables[index].anchor === undefined ? 0.5 : _payTables[index].anchor.x,
            _payTables[index].anchor === undefined ? 0.5 : _payTables[index].anchor.y
          );
        }
      }

      function getuniqueId() {
        value.uniqueID++;
        return 'UniqueID' + value.uniqueID;
      }
    });

    //_payTables = null;
  }

  function onStakeChanged(newStake) {
    if (typeof _payTables !== 'object') return;

    var nonMultipledStake =
      resourceManager.getController('stakeController').CurrentBetPerLine *
      resourceManager.getController('stakeController').CurrentWinLineCount;

    _payTables.forEach(function (value, index) {
      for (var i = 0; i < value.children.length; i++) {
        if (value.showWinsInCurrency) {
          var item = value.children[i];
          if (item.Props.type === 'text' && checkForDefined(item.stakeMultiplier)) {
            if (value.singleText === true) {
              item.setText(`x${item.oak} ${gdk.formatCurrency(item.stakeMultiplier * nonMultipledStake)}`);
            } else {
              item.setText(gdk.formatCurrency(item.stakeMultiplier * nonMultipledStake));
            }
          }
        }
      }
    });
  }

  function getFiles(json) {
    const files = [];
    if (json.fileName) {
      files.push(json.fileName);
    }
    return files;
  }

  return {
    create: create,
    initialise: initialise,
    draw: draw,
    getFiles: getFiles,
    onStakeChanged: onStakeChanged,
  };
})();

// -------------------------------------------------
//  Grid Container
// -------------------------------------------------

standardObjectFactory.gridContainer = (function () {
  var _gridContainers = [];

  function create(json) {
    var container = new PIXI.Container();
    container.columns = json.columns;
    container.rows = json.rows;
    container.boxWidth = json.width;
    container.boxHeight = json.height;
    container.draw = json.showBox;

    // if showBox is true in the json draw a box
    if (container.draw) {
      var graphics = new PIXI.Graphics();
      graphics.lineStyle(2, 0xff0000);
      graphics.drawRect(-container.boxWidth / 2, -container.boxHeight / 2, container.boxWidth, container.boxHeight);
      container.addChild(graphics);
    }

    _gridContainers.push(container);
    return container;
  }

  function initialise(json, container) {}

  function position() {
    // if there's no grid Container objects Return
    if (_gridContainers === undefined || _gridContainers === 0) return;

    _gridContainers.forEach(function (container) {
      // on config assert all postions into a grid
      var children = container.children
        .map(function (value, index) {
          return value;
        })
        .filter((child) => child.Props !== undefined);
      var numChildren = children.length;
      var topLeft = {
        x: -container.boxWidth / 2,
        y: -container.boxHeight / 2,
      };
      var oddColumn = numChildren % container.columns !== 0 ? numChildren % container.columns : 0;
      var oddColumnOffset = container.boxWidth / (oddColumn + 1);
      var rowOffset = container.boxHeight / (container.rows + 1);
      var columnOffset = container.boxWidth / (container.columns + 1);

      children.forEach(function (value, index) {
        var x;
        var y;
        if (index < oddColumn) {
          x = topLeft.x + oddColumnOffset + oddColumnOffset * index;
          y = topLeft.y + rowOffset;
        } else {
          x = topLeft.x + columnOffset + columnOffset * ((index - oddColumn) % container.columns);
          y =
            topLeft.y +
            rowOffset +
            rowOffset * Math.floor((index - oddColumn) / container.columns + (oddColumn === 0 ? 0 : 1));
        }
        for (var name in resourceManager.configuration.layouts) {
          if (resourceManager.configuration.layouts[name].mapped) continue;
          value.Props[name].position.x = x;
          value.Props[name].position.y = y;
        }
        value.position.set(x, y);
      });
    });
  }

  function getFiles(json) {
    return [];
  }

  return {
    create: create,
    initialise: initialise,
    position: position,
    getFiles: getFiles,
  };
})();

// -------------------------------------------------
// END OF STANDARD OBJECT DEFINITIONS
// -------------------------------------------------

if (typeof resourceManager === 'undefined') {
  console.error('Resource Manager needs to be included before standardObjectFactory');
}

standardObjectFactory.onFocus = function () {
  // Window has got focus
  for (var i = 0; i < standardObjectFactory.movies.length; i++) {
    var movie = standardObjectFactory.movies[i];
    if (movie.paused) {
      movie.paused = false;
      movie.gotoAndPlay(movie.pausedFrame);
    }
  }
};

standardObjectFactory.onBlur = function () {
  // Window has lost focus
  for (var i = 0; i < standardObjectFactory.movies.length; i++) {
    var movie = standardObjectFactory.movies[i];
    if (movie.playing) {
      movie.paused = true;
      movie.pausedFrame = movie.currentFrame;
      movie.stop();
    }
  }
};
standardObjectFactory.onLanguageChanged = function () {
  // Update bounds
  for (var i = 0; i < standardObjectFactory.textObjects.length; i++) {
    standardObjectFactory.textObjects[i].checkBounds(
      standardObjectFactory.textObjects[i].Props[layoutController.getCurrentLayout()].scale
    );
  }
};

standardObjectFactory.onLayoutChange = function () {
  // Update all text max widths
  for (var i = 0; i < standardObjectFactory.textObjects.length; i++) {
    if (!standardObjectFactory.textObjects[i].Props.ignoreRescaleOnLayoutChange) {
      standardObjectFactory.textObjects[i].checkBounds(
        standardObjectFactory.textObjects[i].Props[layoutController.getCurrentLayout()].scale
      );
    }
  }

  for (var i = 0; i < standardObjectFactory.buttons.length; i++) {
    var button = standardObjectFactory.buttons[i];
    if (button.buttonSprite !== undefined && button.buttonText !== undefined) {
      var buttonSprite = button.buttonSprite;
      button.buttonText.position.set(
        buttonSprite.position.x + buttonSprite.width * (0.5 - buttonSprite.anchor.x) + button.buttonText.textOffset.x,
        buttonSprite.position.y + buttonSprite.height * (0.5 - buttonSprite.anchor.y) + button.buttonText.textOffset.y
      );
    }
  }

  // Update translatable objects
  for (var i = 0; i < standardObjectFactory.translatableObjects.length; i++) {
    var obj = standardObjectFactory.translatableObjects[i];
    if (obj.updateTranslationText && !obj.Props.ignoreUpdateTranslationOnLayoutChange) {
      obj.updateTranslationText();
    }
  }

  standardObjectFactory.winlineDiagram.winlineDiagrams.forEach(function (value) {
    if (value.children.length > 0) {
      scaleChildren(value.children[0].children);
    }
  });

  function scaleChildren(children) {
    children.forEach(function (value) {
      if ((value.Props.type = 'sprite')) {
        value.scale.set((value.scale.x *= resourceManager.selectedAssetResolution.scaleFactor));
        value.position.set(
          value.x *
            resourceManager.selectedAssetResolution.scaleFactor *
            resourceManager.selectedAssetResolution.scaleFactor,
          value.y *
            resourceManager.selectedAssetResolution.scaleFactor *
            resourceManager.selectedAssetResolution.scaleFactor
        );
      }
      if (value.Props.type == 'text' && value.maxWidth !== undefined)
        value.maxWidth *= resourceManager.selectedAssetResolution.scaleFactor;
    });
  }
};

resourceManager.registerObjectType(
  'sprite',
  standardObjectFactory.createSprite,
  standardObjectFactory.initialiseSprite,
  standardObjectFactory.getSpriteFiles
);
resourceManager.registerObjectType(
  'translatableSprite',
  standardObjectFactory.createTranslatableSprite,
  standardObjectFactory.initialiseTranslatableSprite,
  standardObjectFactory.getTranslatableSpriteFiles
);
resourceManager.registerObjectType(
  'button',
  standardObjectFactory.createButton,
  standardObjectFactory.initialiseButton,
  standardObjectFactory.getButtonFiles,
  standardObjectFactory.destroyButton
);
resourceManager.registerObjectType(
  'movie',
  standardObjectFactory.createMovie,
  standardObjectFactory.initialiseMovie,
  standardObjectFactory.getMovieFiles,
  standardObjectFactory.destroyMovie
);
resourceManager.registerObjectType(
  'text',
  standardObjectFactory.createText,
  standardObjectFactory.initialiseText,
  standardObjectFactory.getTextFiles,
  standardObjectFactory.destroyText
);
resourceManager.registerObjectType(
  'textInput',
  standardObjectFactory.createTextInput,
  standardObjectFactory.initialiseTextInput,
  standardObjectFactory.getTextInputFiles
);
resourceManager.registerObjectType(
  'bitmapText',
  standardObjectFactory.createBitmapText,
  standardObjectFactory.initialiseBitmapText,
  standardObjectFactory.getBitmapTextFiles
);
resourceManager.registerObjectType(
  'container',
  standardObjectFactory.createContainer,
  standardObjectFactory.initialiseContainer,
  standardObjectFactory.getContainerFiles
);
resourceManager.registerObjectType(
  'simpleButton',
  standardObjectFactory.createSimpleButton,
  standardObjectFactory.initialiseSimpleButton,
  standardObjectFactory.getSimpleButtonFiles,
  standardObjectFactory.destroySimpleButton
);
resourceManager.registerObjectType(
  'toggleButton',
  standardObjectFactory.createToggleButton,
  standardObjectFactory.initialiseToggleButton,
  standardObjectFactory.getToggleButtonFiles
);
resourceManager.registerObjectType(
  'graphics',
  standardObjectFactory.createGraphics,
  standardObjectFactory.initialiseGraphics,
  standardObjectFactory.getGraphicsFiles
);
resourceManager.registerObjectType(
  'tilingSprite',
  standardObjectFactory.createTilingSprite,
  standardObjectFactory.initialiseTilingSprite,
  standardObjectFactory.getTilingsSpriteFiles
);
resourceManager.registerObjectType(
  'clock',
  standardObjectFactory.createClock,
  standardObjectFactory.initialiseClock,
  standardObjectFactory.getClockFiles,
  standardObjectFactory.destroyClock
);
resourceManager.registerObjectType(
  'fpsCounter',
  standardObjectFactory.createFPScounter,
  standardObjectFactory.initialiseFPScounter,
  standardObjectFactory.getFPScounterFiles
);
resourceManager.registerObjectType(
  'winlineDiagram',
  standardObjectFactory.winlineDiagram.create,
  standardObjectFactory.winlineDiagram.initialise,
  standardObjectFactory.winlineDiagram.getFiles
);
resourceManager.registerObjectType(
  'payTable',
  standardObjectFactory.payTable.create,
  standardObjectFactory.payTable.initialise,
  standardObjectFactory.payTable.getFiles
);
resourceManager.registerObjectType(
  'gridContainer',
  standardObjectFactory.gridContainer.create,
  standardObjectFactory.gridContainer.initialise,
  standardObjectFactory.gridContainer.getFiles
);

messageBus.subscribe('spinner:GameConfigEvent', standardObjectFactory.onClockConfig);
messageBus.subscribe('spinner:GameConfigEvent', standardObjectFactory.winlineDiagram.drawInternalBoxes);
messageBus.subscribe('spinner:GameConfigEvent', standardObjectFactory.payTable.draw);
messageBus.subscribe('spinner:GameConfigEvent', standardObjectFactory.gridContainer.position);
messageBus.subscribe('stake:stakeChanged', standardObjectFactory.payTable.onStakeChanged);
messageBus.subscribe('languageChanged', standardObjectFactory.onLanguageChanged);

Reflex.registerEventHandler('fullScreen', standardObjectFactory.updateClocksVisibility);
Reflex.registerEventHandler('layoutChange', standardObjectFactory.onLayoutChange);
